import React, { useContext, useState } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { Dialog } from '@reach/dialog'

import { ActionButton } from '../../../../shared/button/ActionButton'
import { IconDelete } from '../../../../shared/svgs'
import { DialogContent } from '../../../../shared/dialog/DialogContent'
import { Button } from '../../../../shared/button'
import { Variant } from '../../../../shared/button/Button'
import { deleteTimeTrackingRecord } from '../../db/records'
import { addDeleteBufferEntry } from '../../db/buffer'
import { syncTimeTracking } from '../../sync'
import { AuthContext } from '../../../../auth/AuthContext'
import { translationsShared } from '../../../../shared/translations/translationsShared'

const TimeTrackingItemDelete: React.FC<{ id: string }> = ({ id }) => {
  const intl = useIntl()
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  const { data: moduleData } = useContext(AuthContext)

  const showDialog = () => {
    setShowDeleteConfirmation(true)
  }

  const dismissDialog = () => {
    setShowDeleteConfirmation(false)
  }

  const deleteRecord = async () => {
    setShowDeleteConfirmation(false)
    await deleteTimeTrackingRecord(id)
    await addDeleteBufferEntry(id)
    if (moduleData?.modules) {
      await syncTimeTracking(moduleData.modules)
    }
  }

  return (
    <>
      <ActionButton onClick={showDialog}>
        <IconDelete className="mr-2 size-5" />
        <FormattedMessage
          id="timeTracking.item.delete"
          defaultMessage="Delete"
        />
      </ActionButton>
      {showDeleteConfirmation && (
        <Dialog
          onDismiss={dismissDialog}
          aria-label={intl.formatMessage({
            id: 'timeTracking.item.delete.confirmation.label',
            defaultMessage:
              'Confirmation popup for deletion of time tracking record',
          })}
        >
          <DialogContent>
            <div className="text-xl font-bold">
              <FormattedMessage
                id="timeTracking.item.delete.confirmation.title"
                defaultMessage="Delete record"
              />
            </div>
            <p className="mt-3">
              <FormattedMessage
                id="timeTracking.item.delete.confirmation.description"
                defaultMessage="Are you sure you want to delete this time tracking record?"
              />
            </p>
            <div className="mt-8 space-x-4 text-right">
              <Button variant={Variant.secondary} onClick={dismissDialog}>
                <FormattedMessage {...translationsShared.cancel} />
              </Button>
              <Button variant={Variant.primary} onClick={deleteRecord}>
                <FormattedMessage {...translationsShared.ok} />
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}

export { TimeTrackingItemDelete }
